export const sanitizeFilename = (name: string) => {
  return name
    .normalize("NFD")
    .replaceAll(/[\u0300-\u036f]/g, "")
    .replaceAll(/\s+/g, "_")
    .replaceAll(/[^a-zA-Z0-9_\-.]/g, "");
};

export const exportSvg = (svg: SVGElement, filename: string) => {
  const svgClone = svg.cloneNode(true) as SVGElement;
  
  const rect = svg.getBoundingClientRect();
  svgClone.setAttribute("width", rect.width.toString());
  svgClone.setAttribute("height", rect.height.toString());
  if (!svgClone.getAttribute("viewBox")) {
    svgClone.setAttribute("viewBox", `0 0 ${rect.width} ${rect.height}`);
  }

  const originalScheme = svg.dataset.muiColorScheme;
  svg.dataset.muiColorScheme = "light";

  const inlineStyles = (target: Element, source: Element) => {
    const computed = globalThis.getComputedStyle(source);
    const style = (target as HTMLElement).style;
    
    const properties = [
      "fill", "stroke", "stroke-width", "stroke-dasharray", "stroke-linecap", 
      "stroke-linejoin", "opacity", "font-family", "font-size", "font-weight", 
      "text-anchor", "display", "visibility", "shape-rendering", "color"
    ];

    properties.forEach(prop => {
      const value = computed.getPropertyValue(prop);
      if (value) style.setProperty(prop, value);
    });

    for (let i = 0; i < source.children.length; i++) {
      if (target.children[i] && source.children[i]) {
        inlineStyles(target.children[i], source.children[i]);
      }
    }
  };

  inlineStyles(svgClone, svg);

  if (originalScheme) {
    svg.dataset.muiColorScheme = originalScheme;
  } else {
    delete svg.dataset.muiColorScheme;
  }

  const backgroundRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  backgroundRect.setAttribute("width", "100%");
  backgroundRect.setAttribute("height", "100%");
  backgroundRect.setAttribute("fill", "white");
  svgClone.insertBefore(backgroundRect, svgClone.firstChild);

  if (!svgClone.getAttribute("xmlns")) {
    svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  }
  
  const serializer = new XMLSerializer();
  let svgStr = serializer.serializeToString(svgClone);

  if (!svgStr.startsWith("<?xml")) {
    svgStr = '<?xml version="1.0" standalone="no"?>\r\n' + svgStr;
  }

  const blob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.svg`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
